import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import BrandList from "@/pages/brand/page";
import BrandDetail from "@/pages/brand/detail/page";
import NewsList from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import ResourcesList from "@/pages/resources/page";
import ResourceDetail from "@/pages/resources/detail/page";
import SearchPage from "@/pages/search/page";
import About from "@/pages/about/page";
import Contact from "@/pages/contact/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "brand",
        element: <BrandList />,
      },
      {
        path: "brand/:id",
        element: <BrandDetail />,
      },
      {
        path: "news",
        element: <NewsList />,
      },
      {
        path: "news/:id",
        element: <NewsDetail />,
      },
      {
        path: "resources",
        element: <ResourcesList />,
      },
      {
        path: "resources/:id",
        element: <ResourceDetail />,
      },
      {
        path: "search",
        element: <SearchPage />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;